<template>
  <el-dialog
    :visible="visible"
    width="500px"
    class="add_booking_dialog"
    :title="$t('message.Booking.selectBookingTitle')"
    @close="$emit('close')"
  >
    <div class="booking_list">
      <div v-if="!value || !value.length" style="font-size: 16px; text-align: center">
        {{ $t('message.Booking.notBookingDate') }}
      </div>
      <div class="booking_item" v-for="item in value" :key="item.key">
        <span>
          <MyTag reverse style="margin-right: 8px" :type="type(item)">
            {{ typeText(item) }}
          </MyTag>
          {{ bookingFormatDate(item.date) }}
        </span>
        <div>
          <el-button :disabled="!item.num" type="primary" size="mini" @click="onAddBooking(item)">
            {{ $t('message.Booking.selectBtn') }}
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import MyTag from "@/components/MyTag.vue";
import { getWeek } from "@/util/util";

export default {
  components: {
    MyTag,
  },
  props: {
    visible: Boolean,
    value: Array,
  },
  data() {
    return {};
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    serviceCode() {
      return "HZMB_H_BOOKING";
    },
    type() {
      return function (item) {
        if (item.limitType === "NOT_LIMIT") return "success";
        else if (item.num) return "link";
        else return "fail";
      };
    },
    typeText() {
      return function (item) {
        if (item.limitType === "NOT_LIMIT") return this.$t("message.Booking.unlimited");
        else if (item.num) return this.$t("message.Booking.haveQuota");
        else return this.$t("message.Booking.noQuota");
      };
    },
  },
  methods: {
    bookingFormatDate(date) {
      return `${this.$formatDate(date, "dd/MM/yyyy")}（${getWeek(date)}）`;
    },
    async onAddBooking(item) {
      try {
        await this.$confirm(
          this.$t('message.Booking.isBooking', [this.bookingFormatDate(item.date)]),
          this.$t("message.Booking.confirmAppDate"),
          {
            confirmButtonText: this.$t("message.confirm"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
          }
        );
        this.$emit("onAddBooking", item);
      } catch (error) {
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add_booking_dialog {
  font-size: 16px;
  /deep/.el-dialog__body {
    padding: 16px;
  }
  /deep/.el-dialog {
    border-radius: 8px;
  }
  /deep/.el-dialog__header {
    padding: 16px 16px 0;
    .el-dialog__title {
      font-size: 20px;
    }
  }
  .booking_item {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 8px;
  }
  .booking_item + .booking_item {
    border-top: 1px solid #d0d0d0;
    padding-top: 16px;
  }
}
</style>
